
import { getScript } from '@/lib/utils';

export default {
  name: 'AppInstagramPost',
  props: {
    review: { type: Object, required: true }
  },
  data() {
    return { showInstagramImage: false };
  },
  mounted() {
    this.initInstagram();
  },
  methods: {
    initInstagram() {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
        setTimeout(() => (this.showInstagramImage = true), 2000);
      } else {
        getScript('//www.instagram.com/embed.js', () => {
          window.instgrm.Embeds.process();
          setTimeout(() => (this.showInstagramImage = true), 2000);
        });
      }
    }
  }
};
